/**
 * Created by sung on 2017-02-10.
 */
export class SearchItem {
  sDate : any;
  eDate : any;
  searchId : any;
  searchText : any;
  searchIsTrue : boolean;

  constructor(sDAte:any, eDate:any, searchId : any, searchText : any, searchIsTrue:boolean) {
    this.sDate = sDAte;
    this.eDate = eDate;
    this.searchId = searchId;
    this.searchText = searchText;
    this.searchIsTrue = searchIsTrue;
  }

}




// WEBPACK FOOTER //
// ./src/app/model/search.ts